import { Omit } from '@40seas/entities/common';
import { BuyerUser, SupplierUser, User } from '@40seas/entities/users';
import { BaseEntityFieldsArray } from '@40seas/models';

export class CreateUserDto extends Omit(User, BaseEntityFieldsArray) {}

export class CreateSupplierUserDto extends Omit(SupplierUser, [...BaseEntityFieldsArray, 'verifyIdentityStatus', 'verifyIdentityId']) {}

export class CreateBuyerUserDto extends Omit(BuyerUser, [...BaseEntityFieldsArray, 'verifyIdentityStatus', 'verifyIdentityId']) {}
